import * as React from "react"
import { AlertTriangle, Trash2 } from "lucide-react"
import { Button } from "./button"

const ConfirmationDialog = ({ 
  open, 
  title, 
  message, 
  onConfirm, 
  onCancel,
  confirmText = "Slet",
  confirmVariant = "destructive",
  icon = "alert"
}) => {
  if (!open) return null
  
  const IconComponent = icon === "trash" ? Trash2 : AlertTriangle
  
  return (
    <div 
      className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[3000]"
      onClick={onCancel}
      data-testid="confirmation-dialog-overlay"
    >
      <div 
        className="bg-zinc-900 border border-zinc-700 rounded-xl shadow-2xl p-6 w-full max-w-md mx-4"
        onClick={(e) => e.stopPropagation()}
        data-testid="confirmation-dialog"
      >
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 rounded-full bg-destructive/20">
            <IconComponent className="h-6 w-6 text-destructive" />
          </div>
          <h2 className="text-lg font-bold text-white">{title}</h2>
        </div>
        <p className="text-zinc-400 mb-6 leading-relaxed whitespace-pre-line">{message}</p>
        <div className="flex justify-end gap-3">
          <Button 
            variant="outline" 
            onClick={onCancel}
            className="border-zinc-600 text-white hover:bg-zinc-800"
            data-testid="confirmation-cancel-btn"
          >
            Annuller
          </Button>
          <Button 
            variant={confirmVariant} 
            onClick={onConfirm}
            data-testid="confirmation-confirm-btn"
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </div>
  )
}
ConfirmationDialog.displayName = "ConfirmationDialog"

export { ConfirmationDialog }
